import React from 'react'
import { connect } from 'react-redux';
import './css/index.css';
import ortho from './js/index';

import { API_GET_JOB_ASSETS, API_NEXT_STEP, API_SEND_COMMENT, BASE_URL } from '../../config';
import { switch_api } from '../../actions/switch_api';

import both from '../../assets/icons/both.svg';
import upper from '../../assets/icons/upper.svg';
import lower from '../../assets/icons/lower.svg';
import occlusion from '../../assets/icons/occlusion.svg';
import menu from '../../assets/icons/menu.svg';
import locks from '../../assets/icons/locks.svg';
import separations from '../../assets/icons/separations.svg';
import grid from '../../assets/icons/mm-grid.svg';
import pdf from '../../assets/icons/pdf.svg';
import transp from '../../assets/icons/transp.svg';
// import back from '../../assets/icons/back.svg';
// import plan_bone from '../../assets/icons/plan_bone.svg';
import info from '../../assets/icons/m_i.svg';
import en from '../../assets/icons/en.svg';
import ru from '../../assets/icons/ru.svg';

import first from '../../assets/icons/first.svg';
import pause from '../../assets/icons/pause.svg';
import play from '../../assets/icons/play.svg';
import last from '../../assets/icons/last.svg';

import occlEn from '../../assets/icons/occlusion_en.svg';
import occlRu from '../../assets/icons/occlusion_ru.svg';

// const getHTML = () => {
//   return { __html: '<div class=ortho-gl-container><div class=ortho-nav-mobile><div class=ortho-nav-mobile-row><a class="ortho-nav-mobile-icon -both"></a><a class="ortho-nav-mobile-icon -upper"></a><a class="ortho-nav-mobile-icon -lower"></a><a class="ortho-nav-mobile-icon -occlusion"></a><a class="ortho-nav-mobile-icon -menu"></a></div><div class=ortho-nav-mobile-row><a class="ortho-nav-mobile-icon -locks"></a><a class="ortho-nav-mobile-icon -separations"></a><a class="ortho-nav-mobile-icon -grid"></a><a class="ortho-nav-mobile-icon -pdf"></a><a class="ortho-nav-mobile-icon -info"></a></div><div class=ortho-nav-mobile-row><a class="ortho-nav-mobile-icon -test" style=float:right;></a><a class="ortho-nav-mobile-icon -plan_bone"></a></div></div><div class=ortho-nav><div class=ortho-nav-row><a class="ortho-nav-cell -active"><div class="ortho-nav-icon -both"></div></a><a class=ortho-nav-cell><div class="ortho-nav-icon -upper"></div></a></div><div class=ortho-nav-row><a class=ortho-nav-cell><div class="ortho-nav-icon -occlusion"></div></a><a class=ortho-nav-cell><div class="ortho-nav-icon -lower"></div></a></div><div class="ortho-nav-row -line"></div><div class=ortho-nav-row><a class="ortho-nav-cell -active"><div class="ortho-nav-icon -locks"></div></a><a class="ortho-nav-cell -active"><div class="ortho-nav-icon -separations"></div></a></div><div class="ortho-nav-row -line"></div><div class=ortho-nav-row><a class=ortho-nav-cell><div class="ortho-nav-icon -grid"></div></a><a class=ortho-nav-cell><div class="ortho-nav-icon -pdf"></div></a></div><div class=ortho-nav-row><a class=ortho-nav-cell><div class="ortho-nav-icon -plan_bone"></div></a><a class=ortho-nav-cell><div class="ortho-nav-icon -test"></div></a></div></div><div class=ortho-info><div class=ortho-info-inner></div></div><div class=ortho-controls><div class=ortho-controls-inner><div class=ortho-controls-line draggable=false></div><div class="ortho-controls-current -up"><span>Капа 1</span></div><div class="ortho-controls-current -down"><span>Капа 1</span></div><div class=ortho-controls-actions><div class=ortho-controls-actions-inner><div class=ortho-controls-actions-item></div><div class=ortho-controls-actions-item></div><div class=ortho-controls-actions-item></div><div class=ortho-controls-actions-item></div></div></div><div class=ortho-controls-slider draggable=false></div></div></div><div class=ortho-loader><div class=ortho-loader-inner><svg width=100 height=100><circle cx=50 cy=50 r=45></circle></svg><div class=ortho-perc>0%</div></div></div><div class=ortho-nowebgl><span>No WebGL Support</span></div></div>' };
// };

class Viewer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  nextStep() {
    let token =  localStorage.getItem('token');

    return fetch(switch_api(API_NEXT_STEP(this.props.match.params.uuid)), {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Authorization': `Token ${token}`,
        'Content-Type': 'application/json; charset=utf-8'
      },
      credentials: 'include'
    })
    .then((response) => {
      if (!response.ok) {
        console.error(`Failed loading { API_NEXT_STEP }: ${response.statusText}`);
        this.setState({loading:false});
      }
      
      window.location = '/home';
    })
    .catch((e) => {
      console.warn(e);
      // this.setState({loading:false});
    })
  }

  comment(comment, cb) {
    let token =  localStorage.getItem('token');
    return fetch(switch_api(API_SEND_COMMENT(this.props.match.params.uuid)), {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Authorization': `Token ${token}`,
        'Content-Type': 'application/json; charset=utf-8'
      },
      credentials: 'include',
      body: JSON.stringify({ comment })
    })
    .then((response) => {
      if (!response.ok) {
        console.error(`Failed loading { API_SEND_COMMENT }: ${response.statusText}`);
        this.setState({loading:false});
      } else {
        cb();
      }
    })
    .catch((e) => {
      console.warn(e);
      // this.setState({loading:false});
    })
  }

  getJobAssets() {
    const get_params = this.props.location.search.slice(1).split('&').map((elm) => {
      const [ key, value ] = elm.split('=');

      return { [key]: value };
    })

    const flow = get_params.filter((elm) => elm.flow);

    fetch(switch_api(API_GET_JOB_ASSETS(this.props.match.params.uuid, flow.length && (flow[0].flow === 'roots_alignment_modelling' || flow[0].flow === 'roots_alignment_modelling_external') && '?folder_name=assets/standard')), {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': `Token ${ localStorage.getItem('token') }`,
        'Content-Type': 'application/json; charset=utf-8'
      },
      credentials: 'include'
    })
      .then((response) => {
        if (!response.ok) {
          console.error(`Failed loading { API_GET_JOB_ASSETS }: ${response.statusText}`);
        }
        return response;
      })
      .then((response) => response.json())
      .then((json) => {
        window.ortho({
          base_url: BASE_URL,
          type: 'main',
          json,
          case: json.patient_tag,
          pdf: {
            en: json.pdf['report_en.pdf'],
            ru: json.pdf['report.pdf']
          },
          nextStep: () => this.nextStep(),
          comment: (data, cb) => this.comment(data, cb),
        });
      })
      .catch((e) => {
        console.error(e);
        // dispatch(userLoggedInFailure('' + e))
        // window.location = '/home';
      });
  }

  componentDidMount() {
    this.getJobAssets();
  }

  render() {
    return (
      <div className="ortho-gl-container">
        <div className="ortho-nav-mobile">
          <div className="ortho-nav-mobile-row">
            <a className="ortho-nav-mobile-icon -menu" style={{backgroundImage: `url(${ menu })`}}/>
            <a className="ortho-nav-mobile-icon -occlusion" style={{backgroundImage: `url(${ occlusion })`}}/>
            <a className="ortho-nav-mobile-icon -lower" style={{backgroundImage: `url(${ lower })`}}/>
            <a className="ortho-nav-mobile-icon -upper" style={{backgroundImage: `url(${ upper })`}}/>
            <a className="ortho-nav-mobile-icon -both" style={{backgroundImage: `url(${ both })`}}/>
          </div>
          <div className="ortho-nav-mobile-row">
            <a className="ortho-nav-mobile-icon -info" style={{backgroundImage: `url(${ info })`}}/>
            <a className="ortho-nav-mobile-icon -pdf" style={{backgroundImage: `url(${ pdf })`}}/>
            <a className="ortho-nav-mobile-icon -grid" style={{backgroundImage: `url(${ grid })`}}/>
            <a className="ortho-nav-mobile-icon -separations" style={{backgroundImage: `url(${ separations })`}}/>
            <a className="ortho-nav-mobile-icon -locks" style={{backgroundImage: `url(${ locks })`}}/>
          </div>
          <div className="ortho-nav-mobile-row">
            <a className="ortho-nav-mobile-icon -transp" style={{backgroundImage: `url(${ transp })`}}/>
            <a className="ortho-nav-mobile-icon -transp_back"/>
            <a className="ortho-nav-mobile-icon -back"/>
            <a className="ortho-nav-mobile-icon -plan_bone"/>
          </div>
        </div>
        <div className="ortho-nav">
          <div className="ortho-nav-row">
            <a className="ortho-nav-cell -both -active">
              <div className="ortho-nav-icon -both" style={{backgroundImage: `url(${ both })`}}/>
            </a>
            <a className="ortho-nav-cell -upper">
              <div className="ortho-nav-icon -upper" style={{backgroundImage: `url(${ upper })`}}/>
            </a>
          </div>
          <div className="ortho-nav-row">
            <a className="ortho-nav-cell -occlusion">
              <div className="ortho-nav-icon -occlusion" style={{backgroundImage: `url(${ occlusion })`}}/>
            </a>
            <a className="ortho-nav-cell -lower">
              <div className="ortho-nav-icon -lower" style={{backgroundImage: `url(${ lower })`}}/>
            </a>
          </div>
          <div className="ortho-nav-row -line" />
          <div className="ortho-nav-row">
            <a className="ortho-nav-cell -locks -active">
              <div className="ortho-nav-icon -locks" style={{backgroundImage: `url(${ locks })`}}/>
            </a>
            <a className="ortho-nav-cell -separations -active">
              <div className="ortho-nav-icon -separations" style={{backgroundImage: `url(${ separations })`}}/>
            </a>
          </div>
          <div className="ortho-nav-row -line" />
          <div className="ortho-nav-row">
            <a className="ortho-nav-cell -grid">
              <div className="ortho-nav-icon -grid" style={{backgroundImage: `url(${ grid })`}}/>
            </a>
            <a className="ortho-nav-cell -pdf">
              <div className="ortho-nav-icon -pdf" style={{backgroundImage: `url(${ pdf })`}}/>
            </a>
          </div>
          <div className="ortho-nav-row">
            <a className="ortho-nav-cell -plan_bone">
              <div className="ortho-nav-icon -plan_bone"/>
            </a>
            <a className="ortho-nav-cell -back">
              <div className="ortho-nav-icon -back"/>
            </a>
            <a className="ortho-nav-cell -transp">
              <div className="ortho-nav-icon -transp" style={{backgroundImage: `url(${ transp })`}}/>
            </a>
            <a className="ortho-nav-cell -transp_back">
              <div className="ortho-nav-icon -transp_back"/>
            </a>
          </div>
        </div>
        <div className="ortho-subnav">
          <div className="ortho-subnav-row">
            <a className="ortho-subnav-cell -en">
              <div className="ortho-subnav-icon -en" style={{backgroundImage: `url(${ en })`}}/>
            </a>
            <a className="ortho-subnav-cell -ru">
              <div className="ortho-subnav-icon -ru" style={{backgroundImage: `url(${ ru })`}}/>
            </a>
          </div>
        </div>
        <div className="ortho-info">
          <div className="ortho-card ortho-card--dotted ortho-correction" style={{height: '100%'}}>
            <div className="ortho-card__header">
              <div className="ortho-btn ortho-card__close" icon>
                <div className="icon icon--close" />
              </div>
            </div>
            <div className="ortho-card__text" style={{ padding: 0, alignItems: 'center' }}>
              <div className="ortho-info-inner ps--focus" />
            </div>
          </div>
          <div className="ortho-occl">
            <div className="ortho-occl-en" style={{backgroundImage: `url(${ occlEn })`}}/>
            <div className="ortho-occl-ru" style={{backgroundImage: `url(${ occlRu })`}}/>
          </div>
          <div className="ortho-card ortho-card--dotted ortho-rework-comment" style={{display: 'none'}}>
            <div className="ortho-card__header" />
            <div className="ortho-card__text">
              <textarea />
            </div>
            <div className="ortho-card__actions">
              <button className="ortho-btn" color="primary">Send</button>
              <button className="ortho-btn" color="error">Cancel</button>
            </div>
          </div>
        </div>
        <div className="ortho-comment">
          <div className="ortho-comment-inner">
            <textarea className="ortho-comment-inner-textarea" col="10" />
            <div className="ortho-info-block -bottom -comment">
              <button disabled className="ortho-comment-btn">Send</button>
              <span> </span>
              <button className="ortho-comment-cancel">Cancel</button>
            </div>
          </div>
        </div>
        <div className="ortho-controls">
          <div className="ortho-controls-inner">
            <div className="ortho-controls-line" draggable="false" />
            <div className="ortho-controls-current -up">
              <span></span>
            </div>
            <div className="ortho-controls-current -down">
              <span></span>
            </div>
            <div className="ortho-controls-actions">
              <div className="ortho-controls-actions-inner">
                <div className="ortho-controls-actions-item" style={{backgroundImage: `url(${ first })`}}/>
                <div className="ortho-controls-actions-item" style={{backgroundImage: `url(${ pause })`}}/>
                <div className="ortho-controls-actions-item" style={{backgroundImage: `url(${ play })`}}/>
                <div className="ortho-controls-actions-item" style={{backgroundImage: `url(${ last })`}}/>
              </div>
            </div>
            <div className="ortho-controls-slider" draggable="false" />
          </div>
        </div>
        <div className="ortho-loader">
          <div className="ortho-loader-inner">
            <svg width={100} height={100}>
              <circle cx={50} cy={50} r={45} />
            </svg>
            <div className="ortho-perc">0%</div>
          </div>
        </div>
        <div className="ortho-nowebgl">
          <span>No WebGL Support</span>
        </div>
      </div>
    );
  }
}

export default connect(({ user }) => ({ user }))(Viewer);



// WEBPACK FOOTER //
// ./src/views/Viewer/main.jsx